import {
    faHome,
    faListUl,
    faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import "./style.css";

const StickyActionBar = ({
  user,
  userImage,
  themeVars,
  onShare,
  shareActive = false,
  onProfileClick,
  children,
}) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (onProfileClick) {
      onProfileClick();
      return;
    }

    navigate(user.role === "learner" ? "/learnerprofile" : "/profile", {
      state: { userProfileId: user._id, username: user.username },
    });
  };

  return (
    <div className="sticky-action-wrapper" style={themeVars}>
      <div className="sticky-action-bar">
        <button
          type="button"
          className="action-btn"
          aria-label="Home"
          title="Home"
          onClick={() => navigate("/")}
        >
          <FontAwesomeIcon icon={faHome} />
        </button>
        <button
          type="button"
          className="action-btn"
          aria-label="Community"
          title="Community"
          onClick={() => navigate("/community")}
        >
          <FontAwesomeIcon icon={faListUl} />
        </button>
        {onShare && (
          <button
            type="button"
            className={`action-btn ${shareActive ? "active" : ""}`}
            aria-label="Share"
            title="Share"
            onClick={onShare}
          >
            <FontAwesomeIcon icon={faShareNodes} />
          </button>
        )}
        {children}
        {user && (
          <button
            type="button"
            className="action-btn profile-btn"
            aria-label="Profile"
            title="Profile"
            onClick={handleProfileClick}
          >
            <img src={userImage} alt="" className="profile-pic" />
          </button>
        )}
      </div>
    </div>
  );
};

export default StickyActionBar;
